import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FaqSection() {
  return <section className="py-20 lg:py-32 px-6 bg-cream relative" data-id="element-28">
      <div className="max-w-3xl mx-auto" data-id="element-29">
        {/* FAQ */}
        <div className="mb-24" data-id="element-30">
          <h2 className="text-3xl font-serif text-charcoal mb-12 text-center" data-id="element-31">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6" data-id="element-32">
            <div className="bg-white p-8 rounded-sm shadow-sm" data-id="element-33">
              <h3 className="text-xl font-serif text-charcoal mb-3" data-id="element-34">
                Can I exercise?
              </h3>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-35">
                Yes, but keep it to walking or yoga during these 14 days. No
                high-intensity cardio. We want to lower cortisol, not spike it
                with intense physical stress.
              </p>
            </div>

            <div className="bg-white p-8 rounded-sm shadow-sm" data-id="element-36">
              <h3 className="text-xl font-serif text-charcoal mb-3" data-id="element-37">
                When will I see results?
              </h3>
              <p className="text-charcoal/70 leading-relaxed" data-id="element-38">
                Most women report seeing facial de-puffing by Day 5, and
                improved sleep quality within the first 3 days.
              </p>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="text-center bg-sage text-white p-12 lg:p-16 rounded-sm shadow-xl relative overflow-hidden" data-id="element-39">
          {/* Decorative circles */}
          <div className="absolute top-0 left-0 w-64 h-64 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-40"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-white/5 rounded-full translate-x-1/2 translate-y-1/2" data-id="element-41"></div>

          <div className="relative z-10" data-id="element-42">
            <h2 className="text-4xl lg:text-5xl font-serif mb-6" data-id="element-43">
              Ready to Reset?
            </h2>
            <p className="text-lg text-white/80 mb-8 max-w-lg mx-auto" data-id="element-44">
              Join thousands of women who have reclaimed their calm and their
              metabolism.
            </p>
            <a href="https://claimtheplan.com/cart/63216796336497:1" target="_blank" rel="noopener noreferrer" className="px-10 py-5 bg-white text-sage font-bold tracking-wide transition-all duration-300 hover:bg-cream hover:shadow-lg hover:-translate-y-1 inline-flex items-center gap-3" data-id="element-45">
              <span data-id="element-46">Get The Blueprint Now</span>
              <span className="text-gold font-serif text-xl" data-id="element-47">— $6.39</span>
              <ArrowRight className="w-5 h-5" data-id="element-48" />
            </a>
            <p className="mt-6 text-sm text-white/60" data-id="element-49">
              Instant Digital Download • Secure Checkout
            </p>
          </div>
        </div>

        {/* Footer */}
        <footer className="mt-24 text-center text-charcoal/40 text-sm" data-id="element-50">
          <p className="mb-4" data-id="element-51">
            © 2024 The Cortisol Reset Blueprint. All rights reserved.
          </p>
          <div className="max-w-2xl mx-auto text-xs leading-relaxed border-t border-charcoal/10 pt-8" data-id="element-52">
            <p className="font-bold mb-2" data-id="element-53">DISCLAIMER</p>
            <p data-id="element-54">
              This guide is for educational purposes only. It is not medical
              advice. Consult your physician before changing your supplements or
              lifestyle if you have underlying hormonal conditions.
            </p>
          </div>
        </footer>
      </div>
    </section>;
}